import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CButton } from '@coreui/react-pro'
import { savePatientDetails } from '../../../../../redux/sidePanel/sidePanelThunk'
import PrimaryCarePhysicianDropdown from '../../../newPatient/PrimaryCarePhysicianDropdown'
import FEATURES from '../../../../../utils/featuresConstants'
import { BetterToggleSwitch } from '../../../../../components/common/Toggle/ToggleSwitch'

export default function PatientMiscEditCard({ setEditPatientPCP }) {
  const dispatch = useDispatch()
  const features = useSelector((state) => state?.user?.features)
  const hospice = useSelector((state) => state.sidePanel.panelEncounter?.patient_hospiceEnrolled)
  const aco = useSelector((state) => state.sidePanel.panelEncounter?.patient_acoEnrolled)
  const pcp = useSelector((state) => state.sidePanel.panelEncounter?.primary_care_physician)

  const [newHospice, setNewHospice] = useState(hospice)
  const [newAco, setNewAco] = useState(aco)
  const [newPcp, setNewPcp] = useState(pcp)

  return (
    <div id={'PatientMiscEditCard'}>
      <div className={'d-flex gap-5 pb-3'}>
        {features?.includes(FEATURES.Hospice) && (
          <div className={'d-flex justify-content-between align-items-center gap-3'}>
            <span> Hospice enrolled</span>
            <BetterToggleSwitch
              isToggledOn={newHospice}
              onToggleChange={(e) => {
                setNewHospice(e?.currentTarget?.checked)
              }}
            />
          </div>
        )}
        {features?.includes(FEATURES.ACO) && (
          <div className={'d-flex justify-content-between align-items-center gap-3'}>
            <span>ACO</span>
            <BetterToggleSwitch
              isToggledOn={newAco}
              onToggleChange={(e) => {
                setNewAco(e?.currentTarget?.checked)
              }}
            />
          </div>
        )}
      </div>
      {features?.includes(FEATURES.MedrinaInvoicePCPs) && (
        <PrimaryCarePhysicianDropdown
          setValues={(newPCPData) => {
            setNewPcp(newPCPData()?.primary_care_physician)
          }}
          primary_care_physician={newPcp}
        />
      )}
      <div className={'d-flex justify-content-end gap-4 pt-2'}>
        <CButton onClick={() => setEditPatientPCP(false)} color={'secondary'}>
          Cancel
        </CButton>
        <CButton
          onClick={async () => {
            await dispatch(
              savePatientDetails({
                acoEnrolled: newAco,
                hospiceEnrolled: newHospice,
                primary_care_physician: newPcp,
              }),
            )
            setEditPatientPCP(false)
          }}
        >
          Save
        </CButton>
      </div>
    </div>
  )
}
